"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card-dash-routes-component"
  }, [_c("h2", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c("div", {
    staticClass: "draft"
  }, [_c("h1", [_vm._v("\n      " + _vm._s(_vm.data) + "\n    ")])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;